//export const API_URL = "http://localhost:8080";
export const API_URL = "https://uat-api.milady-rh.com";
export const API_MEDIA_URL = "https://uat-api.milady-rh.com/admin/media/upload";
// export const API_URL = "https://api.milady-rh.com";
// export const API_MEDIA_URL = "https://api.milady-rh.com/admin/media/upload";
export default API_URL;
